import { render } from "./EditVoter.vue?vue&type=template&id=940b26f0&scoped=true"
import script from "./EditVoter.vue?vue&type=script&lang=ts"
export * from "./EditVoter.vue?vue&type=script&lang=ts"

import "./EditVoter.vue?vue&type=style&index=0&id=940b26f0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-940b26f0"

export default script